var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAccents = function SvgAccents(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22.267c5.67 0 10.267-4.597 10.267-10.267C22.267 6.33 17.67 1.733 12 1.733 6.33 1.733 1.733 6.33 1.733 12c0 5.67 4.597 10.267 10.267 10.267Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m9.067 18.6 1.589-5.256-2.934-.855 3.79-3.79 3.421-3.3-1.588 5.256 2.933.856-3.79 3.789-3.421 3.3Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export { SvgAccents as Component };
export default __webpack_public_path__ + "640c6fdad0fb694c8c06c26a4869445c.svg";